<template>
    <div>
    <el-dialog title="编辑" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form size="small" :model="form" ref="form" :rules="formRules">
            <!-- <el-form-item label="权限名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="form.name" autocomplete="off"></el-input>
            </el-form-item> -->
            
            <el-form-item label="说明" :label-width="formLabelWidth">
                <el-input v-model="form.intro" autocomplete="off"></el-input>
            </el-form-item>

            <el-form-item label="等级名称" prop="type" :label-width="formLabelWidth">
                <el-select v-model="form.type">
                    <el-option label="顶级" :value="0"></el-option>
                    <el-option :label="item.name" :value="item.grade_id" :key="item.grade_id" v-for="item in type"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="权限范围" :label-width="formLabelWidth">
                <el-radio-group v-model="is_user_update">
                    <el-radio :label="1">同步更新用户</el-radio>
                    <el-radio :label="0">不更新</el-radio>
                </el-radio-group>
                <el-tree v-if="category" :data="category" show-checkbox node-key="role_key"
                 :default-expand-all="expand_all" :default-checked-keys="category_ids" :props="defaultProps" @check="handleCheckChange">
                    <div class="tree-node" slot-scope="{data}">
                        <div>
                        <!-- <el-tag type="info" class="style1-tag" v-if="data.level==1">{{ type[data.type].name }}</el-tag> -->
                        <span :class="data.status == 0 ? 'text-d-line' : ''">{{ data.name }} <span v-if="data.category_id">({{ data.category_id }})</span> </span>
                        <span class="red ml10" v-if="data.is_lock == 1">收费</span>
                        </div>
                    </div>
                </el-tree>
            </el-form-item>

            <el-form-item label="状态" :label-width="formLabelWidth">
                <el-radio-group v-model="form.status">
                <el-radio :label="1">显示</el-radio>
                <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible">取 消</el-button>
            <el-button type="primary" @click="editCategory" :loading="loading">确 定</el-button>
        </div>
    </el-dialog>
    </div>
</template>

<script>
import UserRoleApi from '@/api/study/user_role.js';
export default {
    data() {
        return {
            /*左边长度*/
            formLabelWidth: '120px',
            /*是否显示*/
            dialogVisible: false,
            loading: false,
            formRules: {
                // name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
            },
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            expand_all: false,
            category: [],
            category_ids: [],
            is_user_update: 1,
        };
    },
    props: ['open_edit', 'form', 'type'],
    created() {
        this.dialogVisible = this.open_edit;
        this.getRoleIds();
        this.typeChange();
    },
    methods: {
        // 取id
        pushId(data){
            let id = data.role_key;
            let index = this.category_ids.indexOf(id);
            if(index == -1 && (data.level == 3 || (data.type == 60 && data.level == 2) || (data.type == 83 && data.level == 1) || data.key_name == 81 || data.key_name == 82)){
                this.category_ids.push(id);
            }
        },
        // 找子级
        findChildren(data){
            if (data.children && data.children.length > 0 ){
                for (var i = 0; i < data.children.length; i++) {
                    this.findChildren(data.children[i]);
                }
            }else{
                this.pushId(data);
            }
        },
        //监听选中
        handleCheckChange(data, checked) {
            this.category_ids = checked.checkedKeys;
            console.log('save', this.category_ids);

            // this.category_ids = [];
            // checked.checkedNodes.forEach(v => {
            //     this.findChildren(v);
            // });
            // console.log(this.category_ids);
        },
        /*选择类型*/
        typeChange(){
            let self = this;
            UserRoleApi.category({is_tree: 1}, true).then(res => {
                if (res.code == 1) {
                    self.category = res.data;
                }
            });
        },
        /*取权限*/
        getRoleIds(){
            let self = this;
            UserRoleApi.roleIds({role_id: self.form.role_id}, true).then(res => {
                if (res.code == 1) {
                    self.category_ids = res.data;
                }
            });
        },
        /*修改分类*/
        editCategory() {
            let self = this;
            let params = this.form;
            params.category_ids = self.category_ids.toString();
            params.is_user_update = self.is_user_update;
            self.$refs.form.validate((valid) => {
                if (valid) {
                    self.$confirm('确认提交吗?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    })
                    .then(() => {
                        self.loading = true;
                        UserRoleApi.edit(params, true)
                            .then(data =>
                            {
                                self.loading = false;
                                if (self.is_user_update){
                                    this.$notify({
                                        title: '提示',
                                        message: data.msg,
                                        duration: 0
                                    });
                                }else{
                                    self.$message({
                                        message: '恭喜你，修改成功',
                                        type: 'success'
                                    });
                                    self.dialogFormVisible(true);
                                }
                            })
                            .catch(error =>
                            {
                                self.loading = false;
                            });
                    })
                    .catch(() => {});
                }
            });
        },

        /*关闭弹窗*/
        dialogFormVisible(e) {
            if (e) {
                this.$emit('closeDialog', {
                    type: 'success',
                    openDialog: false
                })
            } else {
                this.$emit('closeDialog', {
                    type: 'error',
                    openDialog: false
                })
            }
        },

    }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/importuser/role/part/Edit.vue